// @flow

import { useTranslator } from '@gandi/translate';
import { Popover, PopoverContainer, Text } from '@gandi/ui';

type Props = { reason: string, fqdn: string };

export function UntransferableReason({
  reason,
  fqdn,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <PopoverContainer
      id={`transfer-${fqdn}`}
      interactive
      placement="bottom"
      renderReference={getReferenceProps => (
        <Text tagName="a" href="#" role="button" {...getReferenceProps()}>
          {__('Why?')}
        </Text>
      )}
    >
      {getTooltipProps => (
        <Popover title="" {...getTooltipProps()}>
          {reason}
        </Popover>
      )}
    </PopoverContainer>
  );
}
